/**
 * `/code-review/status-checks` — *Status Checks* section.
 * Wired to the `installation_settings.status_checks` column added by
 * migration `007_coding_agents_and_status_checks.sql` (Phase 13).
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewStatusChecks() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="statusChecks"
        title="Status Checks"
        subtitle="Choose which CI status checks Feluda surfaces in the PR summary."
      />
    </main>
  );
}
